import React,{ createContext, useContext, useState } from "react";

// type UserContextProps = {
//   continued;
//   setContinued: VoidFunction;
// };
export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [continued, setContinued] = useState(false);
  // const userProgress = 5;

  const toggleContinue = () => {
    setContinued((prev) => !prev);
  };

  return (
    <UserContext.Provider
      value={{
        continued,
        setContinued: toggleContinue,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContext);
};
